import './article.scss'

if (document.querySelector('.article')) {
  const label = document.querySelector('.table-of-contents__label')
  label?.addEventListener('click', function () {
    console.log(this)
    console.log(this.parentNode.classList.toggle('active'))
  })

  ;(function ($) {
    const anchors = $('body').find('span[data-id="toc"]')

    $(window).scroll(function () {
      var scrollTop = $(document).scrollTop()

      // highlight the last scrolled-to: set everything inactive first
      for (var i = 0; i < anchors.length; i++) {
        $('a[href="#' + $(anchors[i]).attr('id') + '"]').removeClass('active')
      }

      // then iterate backwards, on the first match highlight it and break
      for (var i = anchors.length - 1; i >= 0; i--) {
        if (scrollTop > $(anchors[i]).offset().top - 120) {
          $('a[href="#' + $(anchors[i]).attr('id') + '"]').addClass('active')
          break
        }
      }
    })
  })(window.jQuery)
}
